import React from "react";
import "./scss/style.scss";
import Routes from "./Routes";

const App = () => <Routes />;
export default App;
